import { customTwMerge } from '@/helpers/theme';
import { CSSProperties } from 'react';

/**
 * The star icon filled with a real background colour: the rating colour unless a `bg-*` class
 * overrides it. A mask instead of Icon: Icon recolours its black SVG with a CSS filter chain that
 * only approximates the colour, and iOS Safari renders that approximation visibly off from the
 * same colour set in CSS.
 */
const StarIcon = ({ className, style }: { className?: string; style?: CSSProperties }) => (
  <span
    aria-hidden
    // Block, so the unlit star fills its wrapper's top-left corner exactly where the lit overlay
    // (absolute inset-0) lands; inline it sits on the text baseline, below the overlay.
    className={customTwMerge('star-icon bg-warning-500 block h-[16px] w-[16px]', className)}
    style={style}
  />
);

export default StarIcon;
